var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_416_5813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0007 20.952C22.0029 21.3738 21.914 21.7913 21.7397 22.1767C21.5654 22.5622 21.3098 22.9068 20.9899 23.1877C20.6699 23.4687 20.2929 23.6796 19.8838 23.8064C19.4746 23.9332 19.0428 23.9731 18.6168 23.9233C17.0662 23.6977 15.9299 22.3709 15.9677 20.8299V3.11357C15.9302 1.57098 17.0693 0.243374 18.622 0.0201904C19.0475 -0.028803 19.4788 0.0116129 19.8874 0.138765C20.2959 0.265917 20.6722 0.476907 20.9916 0.75778C21.311 1.03865 21.5661 1.38301 21.7401 1.76807C21.914 2.15313 22.0029 2.57012 22.0007 2.99146V20.952Z",
    fill: "#F9AB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01649 18.0161C4.68248 18.0161 6.03298 19.3442 6.03298 20.9824C6.03298 22.6206 4.68248 23.9487 3.01649 23.9487C1.35051 23.9487 0 22.6206 0 20.9825C0 19.3442 1.35051 18.0161 3.01649 18.0161ZM10.9535 9.02566C9.2797 9.11591 7.98093 10.4966 8.01986 12.1446V20.1124C8.01986 22.2748 8.98743 23.5875 10.4051 23.8673C10.8446 23.9549 11.2984 23.9452 11.7336 23.8389C12.1688 23.7326 12.5745 23.5324 12.9213 23.2528C13.2681 22.9732 13.5472 22.6212 13.7385 22.2223C13.9297 21.8234 14.0283 21.3877 14.027 20.9467V12.0073C14.0277 11.6121 13.9484 11.2208 13.7937 10.856C13.639 10.4913 13.412 10.1605 13.1259 9.88296C12.8398 9.60542 12.5003 9.38668 12.1274 9.2395C11.7544 9.09233 11.3553 9.01966 10.9535 9.02574V9.02566Z",
    fill: "#E37400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_5813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/google_analytics.460e78e5c6c334b6b53f44eba1fc78e2.svg";
export { ForwardRef as ReactComponent };